export function normalizeTimestamp(value) {
  if (value == null || value === '') return '';
  const raw = String(value).trim();
  // Preserve second-level timestamps already used by the current Process Advisor engine.
  const normalized = raw.replace('T', ' ');
  const match = normalized.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})/);
  return match ? `${match[1]} ${match[2]}` : normalized;
}

export function stableEventId(platform, caseId, index, row = {}) {
  const nativeId = row.event_id || row.eventId || row.sys_id || row.history_id || row.historyId;
  if (nativeId) return `${platform}:${nativeId}`;
  const field = row.activity_type || row.activityType || row.field || '';
  const timestamp = normalizeTimestamp(row.timestamp || row.created || row.sys_created_on || '');
  return `${platform}:${caseId}:${timestamp}:${field}:${index}`;
}

export function extractIndexedAttributes(row, prefix) {
  const attrs = {};
  Object.keys(row || {}).forEach((key) => {
    if (new RegExp(`^${prefix}\\d+$`).test(key)) attrs[key] = row[key];
  });
  return attrs;
}

export function attributeDefinitionsFromLegacy(definitions = [], prefix = 'ta') {
  return (definitions || []).map((def, index) => ({
    id: def?.id || `${prefix}${index}`,
    key: def?.id || `${prefix}${index}`,
    name: def?.field || def?.name || def?.label || `${prefix}${index}`,
    sourceField: def?.attributeID || def?.fieldName || def?.field || '',
    dataType: def?.schema || def?.type || 'string',
  }));
}
